import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Toast } from 'primereact/toast';

const DownloadSection = ({ downloadLinks = [], zipDownloadLink = null }) => {
    const toastRef = React.useRef(null);
    const [copySuccess, setCopySuccess] = useState(false);

    const handleDownload = (link, filename = 'download') => {
        const a = document.createElement('a');
        a.href = link;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const handleCopyDownloadLink = () => {
        if (zipDownloadLink) {
            navigator.clipboard.writeText(zipDownloadLink).then(() => {
                toastRef.current?.show({ 
                    severity: 'success', 
                    summary: 'Copied', 
                    detail: 'Download link copied to clipboard!',
                    life: 2000 
                });
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            }).catch(() => {
                toastRef.current?.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Failed to copy link.',
                    life: 2000 
                });
            });
        }
    };

    return (
        <Card>
            <Toast ref={toastRef} position="top-right" />
            
            <h3 className="mb-3">Download Converted Images</h3>
            
            {zipDownloadLink ? (
                <>
                    <div className="mb-4">
                        <p className="mb-2 text-600 font-semibold">Download All as ZIP:</p>
                        <Button 
                            label="📦 Download All as ZIP" 
                            icon="pi pi-download" 
                            className="p-button-success w-full mb-3"
                            onClick={() => handleDownload(zipDownloadLink, 'converted-images.zip')}
                        />
                    </div>

                    <div className="mb-4">
                        <p className="mb-2 text-600 font-semibold">Share Download Link (Expires in 1 hour):</p>
                        <div className="flex gap-2 align-items-center">
                            <input 
                                type="text"
                                value={zipDownloadLink}
                                readOnly
                                className="w-full p-3 border-1 surface-border border-round surface-50"
                                style={{ fontSize: '0.875rem' }}
                            />
                            <Button 
                                icon={`pi ${copySuccess ? 'pi-check' : 'pi-copy'}`}
                                onClick={handleCopyDownloadLink}
                                className={copySuccess ? 'p-button-success' : ''}
                                title="Copy to clipboard"
                            />
                        </div>
                        <small className="text-500 block mt-2">This link can be shared with others to download the converted images.</small>
                    </div>

                    <Divider />
                </>
            ) : null}

            {downloadLinks && downloadLinks.length > 0 ? (
                <div>
                    <p className="mb-3 text-600 font-semibold">Individual Downloads:</p>
                    {downloadLinks.map((link, index) => (
                        <Button 
                            key={index}
                            label={`⬇️ Download Image ${index + 1}.jpg`}
                            icon="pi pi-file"
                            className="p-button-info mr-2 mb-2"
                            onClick={() => handleDownload(link, `converted-image-${index + 1}.jpg`)}
                        />
                    ))}
                </div>
            ) : (
                <p className="text-center text-500">No converted images available for download</p>
            )}
        </Card>
    );
};

export default DownloadSection;